import React from 'react';
import Reference from './Reference';
import { useTranslation } from 'react-i18next';
import BreadCrumbs from '../common/BreadCrumbs';
import Page from '../common/Page';

const ReferencePage = () => {

    const { t } = useTranslation();

    return (
        <Page>
            <BreadCrumbs stack={[
                {title: t("Domů"), path: "/"},
                {title: t("Reference"), path: "/reference"}
            ]} />
            <Reference />
        </Page>
    );
};

export default ReferencePage;